import { useState } from "react";
import { X, Check, Triangle, RotateCcw, ArrowRight } from "lucide-react";

export const Simulator = ({ scenario, onClose }) => {
  const [step, setStep] = useState(0);
  const [picked, setPicked] = useState(null);
  const [score, setScore] = useState({ good: 0, total: 0 });
  const total = scenario.steps.length;
  const s = scenario.steps[step];
  const done = step >= total;

  const choose = (c) => {
    if (picked) return;
    setPicked(c);
    setScore((sc) => ({ good: sc.good + (c.good ? 1 : 0), total: sc.total + 1 }));
  };
  const next = () => { setPicked(null); setStep((v) => v + 1); };
  const restart = () => { setStep(0); setPicked(null); setScore({ good: 0, total: 0 }); };

  return (
    <div data-testid="simulator-overlay" className="fixed inset-0 z-[60] bg-[#0B1B33]/70 backdrop-blur-sm grid place-items-center p-4" onClick={onClose}>
      <div className="bg-white rounded-3xl max-w-lg w-full max-h-[88vh] overflow-y-auto p-6 sm:p-8" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="text-xs font-bold uppercase tracking-wider text-[#C89A3E]">S'exercer</div>
            <h3 className="font-heading text-xl font-bold text-[#012141]">{scenario.title}</h3>
            <p className="text-sm text-slate-500">{scenario.persona}</p>
          </div>
          <button data-testid="simulator-close" onClick={onClose} className="grid place-items-center w-9 h-9 rounded-full text-slate-500 hover:bg-slate-100"><X size={18} /></button>
        </div>

        {!done ? (
          <div className="mt-5">
            <div className="text-xs font-semibold text-slate-400 mb-2">Étape {step + 1} / {total}</div>
            <div className="rounded-2xl bg-[#012141]/5 p-4 text-[#012141] font-medium">{s.situation}</div>
            <div className="mt-4 space-y-2">
              {s.choices.map((c, i) => {
                const active = picked === c;
                return (
                  <button key={i} data-testid={`sim-choice-${i}`} onClick={() => choose(c)} disabled={!!picked}
                    className={`w-full text-left px-4 py-3 rounded-2xl border-2 transition-all ${!picked ? "border-[#012141]/12 hover:border-[#C89A3E]" : active ? (c.good ? "border-green-500 bg-green-50" : "border-red-400 bg-red-50") : "border-[#012141]/8 opacity-60"}`}>
                    <span className="text-sm font-semibold text-[#012141]">{c.label}</span>
                    {active && <span className={`mt-2 flex items-start gap-2 text-sm ${c.good ? "text-green-700" : "text-red-600"}`}>{c.good ? <Check size={16} className="mt-0.5" /> : <Triangle size={14} className="mt-1" />} {c.feedback}</span>}
                  </button>
                );
              })}
            </div>
            {picked && (
              <button data-testid="sim-next" onClick={next} className="mt-5 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#012141] text-white font-semibold hover:bg-[#00172E] transition-all">
                {step + 1 < total ? "Continuer" : "Voir le bilan"} <ArrowRight size={16} />
              </button>
            )}
          </div>
        ) : (
          <div className="mt-6 text-center" data-testid="sim-result">
            <div className="text-4xl font-bold font-heading text-[#012141]">{score.good}/{score.total}</div>
            <p className="mt-2 text-slate-600">{score.good === score.total ? "Sans faute — vous maîtrisez ce profil." : score.good >= score.total / 2 ? "Bien joué — quelques réflexes à affiner." : "À retravailler — relisez les scripts et objections."}</p>
            <button data-testid="sim-restart" onClick={restart} className="mt-5 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#C89A3E] text-[#012141] font-bold hover:brightness-95 transition-all"><RotateCcw size={16} /> Recommencer</button>
          </div>
        )}
      </div>
    </div>
  );
};
